import React from 'react'

import { SVG as SVGBase } from './core'
import { AspectRatio } from './AspectRatio'

export const SVG = React.forwardRef(({ svg, fill, ...props }, ref) => (
  <AspectRatio ref={ref} {...props}>
    <SVGBase as={svg} fill={fill} width="100%" height="100%" />
  </AspectRatio>
))
